import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../../core/winpresentation/SimplePresentationRunner";
import {BenjiKIV} from "../../BenjiKIV";
import {BenjiKIVStatics} from "../../BenjiKIVStatics";
import {gsap} from "gsap";
import {ISymbol} from "../../../core/reel/ReelInterfaces";
import {BenjiKIVStackedSymbol} from "../../reels/BenjiKIVStackedSymbol";
import {BenjiKIVWildSymbol} from "../../reels/BenjiKIVWildSymbol";
import {BenjiKIVSound} from "../../sound/BenjiKIVSound";

/**
 * Created by Jerker Nord on 2022-11-22.
 */

export class BenjiKIVMidNudgeRunner implements SimplePresentation {

    private _mainTL:gsap.core.Timeline;
    private _controller:SimplePresentationRunnerController;
    private _currentSoundStep:number = -1

    constructor() {

    }

    public shouldRun():boolean {
        for(let i:number = 0; i < BenjiKIV.model.mNudgeReels.length; i++) {
            if(BenjiKIV.model.mNudgeReels[i] !== 0) {
                return true;
            }
        }
        return false;
    }

    public start(controller:SimplePresentationRunnerController):void {
        this._controller = controller;

        this._mainTL = gsap.timeline({
            onComplete : () => {
                this.complete();
            }
        });

        this._mainTL.add(() => this._controller.setSkipCallback(() => this.skip()));

        //Small delay if nudge on last reel to give it time to change to dead
        if(BenjiKIV.model.mNudgeReels[4] !== 0 && BenjiKIV.model.isWildNudge == false) {
            this._mainTL.add(gsap.timeline({delay : 0.3}));
        }

        const allNudgeReelsTL:gsap.core.Timeline[] = [];
        for(let i:number = 0; i < BenjiKIV.model.mNudgeReels.length; i++) {
            if(BenjiKIV.model.mNudgeReels[i] !== 0) {
                allNudgeReelsTL.push(this.nudgeReel(i, BenjiKIV.allReelView.reelModels[i].reelView.activateStackedReel(), BenjiKIV.model.mNudgeReels[i]));
            }
        }
        this._mainTL.add(allNudgeReelsTL);
    }

    private nudgeReel(reelId:number, stackedSymbolsContainer:PIXI.Container, steps:number):gsap.core.Timeline {
        let reverse:boolean = false;
        let target:number = 0;
        let splitReelMultiplier:number = 1;
        if(BenjiKIV.model.data.enhancerReel && BenjiKIV.model.data.enhancerReel[reelId] == 1) {
            splitReelMultiplier = 2;
        }
        const delayBetweenNudges:number = 0.2;
        if(steps < 0) {
            reverse = true;
        }
        const tl:gsap.core.Timeline = gsap.timeline();
        const endNudgeNumber:number = Math.abs(steps * splitReelMultiplier);
        const nudgeDuration:number = 0.1 / splitReelMultiplier;//Shorter duration if its split sym nudge
        const overShootDuration:number = 0.1;
        const overShoot:number = reverse ? -10 : 10;

        //Find mid sym stacked
        let stackedSym:BenjiKIVStackedSymbol;
        let symbols:ISymbol[] = BenjiKIV.allReelView.reelModels[reelId].reelView.symbols;
        for(let i:number = 1; i < symbols.length - 1; i++) {
            if(symbols[i].stackedSymbolName.indexOf("_MID") > -1) {
                stackedSym = <BenjiKIVStackedSymbol>symbols[i];
                if(i == 2) {
                    stackedSym.setMultiContainerPosition(BenjiKIVWildSymbol.MULTIPLIER_TEXT_CONTAINER_BOTTOM_OFFSET);
                } else if(i == 6) {
                    stackedSym.setMultiContainerPosition(BenjiKIVWildSymbol.MULTIPLIER_TEXT_CONTAINER_TOP_OFFSET);
                }
                break;
            }
        }

        for(let i:number = 0; i < endNudgeNumber; i++) {
            if(reverse == true) {
                target -= BenjiKIVStatics.stepSize / splitReelMultiplier;
            } else {
                target += BenjiKIVStatics.stepSize / splitReelMultiplier;
            }

            //Do nudge
            tl.add([
                () => this.playNudgeStepSound(i),
                gsap.to(stackedSymbolsContainer.position, {
                    duration : nudgeDuration,
                    y : target,
                    ease : "none"
                }),
                stackedSym!.updateMultiplier(splitReelMultiplier + (1 + i))
            ]);

            tl.add(() => {
                if((i == 0 && splitReelMultiplier == 1) || (i == 1 && splitReelMultiplier == 2)) {
                    stackedSym.setMultiContainerPosition(BenjiKIVWildSymbol.MULTIPLIER_TEXT_CONTAINER_CENTER_OFFSET);
                }
            });

            //Do overshoot
            tl.add(gsap.to(stackedSymbolsContainer.position, {duration : overShootDuration, y : target + overShoot}));
            tl.add(gsap.to(stackedSymbolsContainer.position, {duration : overShootDuration * 2, y : target}));

            tl.add(gsap.timeline({delay : delayBetweenNudges}));
        }

        tl.add(() => BenjiKIV.allReelView.reelModels[reelId].reelView.activateNormalReel(steps));

        tl.add(BenjiKIV.overlayScatterView.checkOverlayOnTopOfMultiplier(reelId, 3));

        return tl;
    }

    private playNudgeStepSound(step:number):void {
        if(step > this._currentSoundStep) {
            if(step % 2 == 0) {
                BenjiKIV.soundPlayer.playSound(BenjiKIVSound.MID_NUDGE_01)
            } else {
                BenjiKIV.soundPlayer.playSound(BenjiKIVSound.MID_NUDGE_02)
            }
            this._currentSoundStep = step;
        }
    }

    private skip():void {
        this._mainTL.totalProgress(1);
    }

    private complete():void {
        this._currentSoundStep = -1;
        this._controller.finish();
    }
}